
// You can write more code here

/* START OF COMPILED CODE */

import ChunkBase from "../../ChunkBase";
import ChunkBoundaries from "../../../components/ChunkBoundaries";
import BoundsMarker from "../../editor/BoundsMarker";
import DecorationFloatingPoleLong from "../../decorations/shipwreck/DecorationFloatingPoleLong";
import PlatformMarkerJungleLog from "../../editor/platform-markers/jungle/PlatformMarkerJungleLog";
import SmallGemMarker from "../../editor/entity-markers/SmallGemMarker";
import SmashableMarkerCrate from "../../editor/entity-markers/SmashableMarkerCrate";
import MegaGemMarker from "../../editor/entity-markers/MegaGemMarker";
import PlatformMarkerJungleLogLong from "../../editor/platform-markers/jungle/PlatformMarkerJungleLogLong";
import PlatformMarkerJungleLogMid from "../../editor/platform-markers/jungle/PlatformMarkerJungleLogMid";
import SimpleBreakableBlocker from "../../../components/platformer/SimpleBreakableBlocker";
import CheckpointMarker from "../../editor/CheckpointMarker";
/* START-USER-IMPORTS */
/* END-USER-IMPORTS */

export default class ShipwreckChunk4 extends ChunkBase {

  constructor(scene: Phaser.Scene, x?: number, y?: number) {
    super(scene, x ?? 0, y ?? 384);

    // editor_bounds_left
    const editor_bounds_left = new BoundsMarker(scene, 221, 267);
    this.add(editor_bounds_left);

    // editor_bounds_right
    const editor_bounds_right = new BoundsMarker(scene, 4163, 267);
    this.add(editor_bounds_right);

    // pole_long_float_png_1
    const pole_long_float_png_1 = new DecorationFloatingPoleLong(scene, 541, 139);
    this.add(pole_long_float_png_1);

    // pole_long_float_png
    const pole_long_float_png = new DecorationFloatingPoleLong(scene, 283, 139);
    this.add(pole_long_float_png);

    // platformLog_2
    const platformLog_2 = new PlatformMarkerJungleLog(scene, 679, -165);
    this.add(platformLog_2);

    // platformLog_3
    const platformLog_3 = new PlatformMarkerJungleLog(scene, 1120, -294);
    this.add(platformLog_3);

    // platformLog_5
    const platformLog_5 = new PlatformMarkerJungleLog(scene, 1772, -274);
    this.add(platformLog_5);

    // gemMarker
    const gemMarker = new SmallGemMarker(scene, 1127, -344);
    this.add(gemMarker);

    // gemMarker_1
    const gemMarker_1 = new SmallGemMarker(scene, 1769, -327);
    this.add(gemMarker_1);

    // gemMarker_2
    const gemMarker_2 = new SmallGemMarker(scene, 2494, -319);
    this.add(gemMarker_2);

    // gemMarker_3
    const gemMarker_3 = new SmallGemMarker(scene, 2190, -30);
    this.add(gemMarker_3);

    // crateMarker
    const crateMarker = new SmashableMarkerCrate(scene, 981, -146);
    this.add(crateMarker);

    // pole_long_float_png_4
    const pole_long_float_png_4 = new DecorationFloatingPoleLong(scene, 1369, 142);
    this.add(pole_long_float_png_4);

    // pole_long_float_png_5
    const pole_long_float_png_5 = new DecorationFloatingPoleLong(scene, 1675, 142);
    this.add(pole_long_float_png_5);

    // pole_long_float_png_6
    const pole_long_float_png_6 = new DecorationFloatingPoleLong(scene, 2004, 140);
    this.add(pole_long_float_png_6);

    // gemMarker_6
    const gemMarker_6 = new SmallGemMarker(scene, 680, -214);
    this.add(gemMarker_6);

    // gemMarker_7
    const gemMarker_7 = new SmallGemMarker(scene, 1240, -33);
    this.add(gemMarker_7);

    // gemMarker_8
    const gemMarker_8 = new SmallGemMarker(scene, 3468, -48);
    this.add(gemMarker_8);

    // gemMarker_10
    const gemMarker_10 = new SmallGemMarker(scene, 2591, -89);
    this.add(gemMarker_10);

    // gemMarker_11
    const gemMarker_11 = new SmallGemMarker(scene, 3743, -59);
    this.add(gemMarker_11);

    // gemMarker_12
    const gemMarker_12 = new SmallGemMarker(scene, 2986, -28);
    this.add(gemMarker_12);

    // gemMarker_13
    const gemMarker_13 = new SmallGemMarker(scene, 546, -66);
    this.add(gemMarker_13);

    // gemMarker_14
    const gemMarker_14 = new SmallGemMarker(scene, 424, -64);
    this.add(gemMarker_14);

    // megaGemMarker
    const megaGemMarker = new MegaGemMarker(scene, 1825, -45);
    this.add(megaGemMarker);

    // megaGemMarker_1
    const megaGemMarker_1 = new MegaGemMarker(scene, 2645, -39);
    this.add(megaGemMarker_1);

    // megaGemMarker_2
    const megaGemMarker_2 = new MegaGemMarker(scene, 1100, -63);
    this.add(megaGemMarker_2);

    // platformMarkerLogLong
    const platformMarkerLogLong = new PlatformMarkerJungleLogLong(scene, 693, -2);
    this.add(platformMarkerLogLong);

    // platformMarkerLogMid
    const platformMarkerLogMid = new PlatformMarkerJungleLogMid(scene, 3616, 9);
    this.add(platformMarkerLogMid);

    // platformMarkerLogLong_1
    const platformMarkerLogLong_1 = new PlatformMarkerJungleLogLong(scene, 1659, 17);
    this.add(platformMarkerLogLong_1);

    // pole_long_float_png_8
    const pole_long_float_png_8 = new DecorationFloatingPoleLong(scene, 832, 139);
    this.add(pole_long_float_png_8);

    // pole_long_float_png_9
    const pole_long_float_png_9 = new DecorationFloatingPoleLong(scene, 1098, 139);
    this.add(pole_long_float_png_9);

    // pole_long_float_png_11
    const pole_long_float_png_11 = new DecorationFloatingPoleLong(scene, 3757, 139);
    this.add(pole_long_float_png_11);

    // pole_long_float_png_12
    const pole_long_float_png_12 = new DecorationFloatingPoleLong(scene, 3466, 139);
    this.add(pole_long_float_png_12);

    // pole_long_float_png_14
    const pole_long_float_png_14 = new DecorationFloatingPoleLong(scene, 2952, 145);
    this.add(pole_long_float_png_14);

    // pole_long_float_png_15
    const pole_long_float_png_15 = new DecorationFloatingPoleLong(scene, 2623, 147);
    this.add(pole_long_float_png_15);

    // pole_long_float_png_16
    const pole_long_float_png_16 = new DecorationFloatingPoleLong(scene, 2317, 147);
    this.add(pole_long_float_png_16);

    // platformMarkerLogLong_4
    const platformMarkerLogLong_4 = new PlatformMarkerJungleLogLong(scene, 2615, 22);
    this.add(platformMarkerLogLong_4);

    // crateMarker_1
    const crateMarker_1 = new SmashableMarkerCrate(scene, 1702, -127);
    this.add(crateMarker_1);

    // crateMarker_2
    const crateMarker_2 = new SmashableMarkerCrate(scene, 2508, -123);
    this.add(crateMarker_2);

    // platformLog_6
    const platformLog_6 = new PlatformMarkerJungleLog(scene, 2491, -269);
    this.add(platformLog_6);

    // checkpointMarker
    const checkpointMarker = new CheckpointMarker(scene, 354, -33);
    this.add(checkpointMarker);

    // checkpointMarker_1
    const checkpointMarker_1 = new CheckpointMarker(scene, 2821, -16);
    this.add(checkpointMarker_1);

    // this (components)
    const thisChunkBoundaries = new ChunkBoundaries(this);
    thisChunkBoundaries.leftBoundsMarker = editor_bounds_left;
    thisChunkBoundaries.rightBoundsMarker = editor_bounds_right;

    // crateMarker_1 (components)
    const crateMarker_1SimpleBreakableBlocker = SimpleBreakableBlocker.getComponent(crateMarker_1);
    crateMarker_1SimpleBreakableBlocker.allowedCharacter = "panda";

    // crateMarker_2 (components)
    const crateMarker_2SimpleBreakableBlocker = SimpleBreakableBlocker.getComponent(crateMarker_2);
    crateMarker_2SimpleBreakableBlocker.allowedCharacter = "ice";
    // awake handler
    this.scene.events.once("scene-awake", () => this.awake());

    /* START-USER-CTR-CODE */
    // Write your code here.
    /* END-USER-CTR-CODE */
  }

  /* START-USER-CODE */

  // Write your code here.

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
